import React from 'react';
import { TopAlarmsBarChartCard } from './AlarmsBarChartCard/AlarmsBarChartCard';
import { useFetchAlarmsData } from '@/hooks/AssetsStudioPage/MainContent/Alarms/useFetchAlarmsData';
import { AlertsTableCard } from './AlarmsTableCard';

interface AlarmsProps {
  setAlarmsCounters: any;
}

export const Alarms = ({ setAlarmsCounters }: AlarmsProps) => {
  const {
    topAlarmsData,
    alarmsTableData,
    isFetchingAlarmsTableData,
    isFetchingTopAlarmsData,
    isLoadingAlarmsTableData,
    isLoadingTopAlarmsData,
    isChartError,
    isTableError,
  } = useFetchAlarmsData();

  return (
    <div className="h-[calc(100vh-11rem)] flex gap-4 relative">
      <div className="w-full h-full flex flex-col gap-4">
        <div className="h-1/3">
          <TopAlarmsBarChartCard
            chartData={topAlarmsData}
            isError={isChartError}
            hasTableData={true}
            isLoading={isLoadingTopAlarmsData || isFetchingTopAlarmsData}
          />
        </div>
        <div className="h-2/3">
          <AlertsTableCard
            tableData={alarmsTableData}
            isError={isTableError}
            isLoading={isLoadingAlarmsTableData || isFetchingAlarmsTableData}
          />
        </div>
      </div>
    </div>
  );
};
